// Konfiguracja i selektory
const selectors = {
  wishlistBtn: '[data-product-id]',
};

// Klucz do localStorage
const WISHLIST_KEY = 'shopify-wishlist';

// Główna klasa
class Wishlist {
  constructor() {
    this.items = this.getWishlist();
    this.updateButtons();
    this.init();
  }

  // Inicjalizacja - nasłuchiwanie kliknięć
  init() {
    document.addEventListener('click', (event) => {
      const wishlistBtn = event.target.closest(selectors.wishlistBtn);
      if (wishlistBtn) {
        this.handleWishlistClick(wishlistBtn);
      }
    });
  }

  // Obsługa kliknięcia w przycisk
  handleWishlistClick(button) {
    const productId = button.dataset.productId;
    const isActive = button.classList.contains('active');

    if (isActive) {
      this.removeFromWishlist(productId);
      button.classList.remove('active');
    } else {
      this.addToWishlist(productId);
      button.classList.add('active');
    }
  }

  // Pobierz listę życzeń z localStorage
  getWishlist() {
    const wishlist = localStorage.getItem(WISHLIST_KEY);
    return wishlist ? JSON.parse(wishlist) : [];
  }

  // Zapisz listę życzeń do localStorage
  saveWishlist() {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(this.items));
  }

  // Dodaj produkt do listy
  addToWishlist(productId) {
    if (!this.items.includes(productId)) {
      this.items.push(productId);
      this.saveWishlist();
    }
  }

  // Usuń produkt z listy
  removeFromWishlist(productId) {
    this.items = this.items.filter(id => id !== productId);
    this.saveWishlist();
  }

  // Aktualizuj stan przycisków na stronie
  updateButtons() {
    const allButtons = document.querySelectorAll(selectors.wishlistBtn);
    allButtons.forEach(button => {
      const productId = button.dataset.productId;
      if (this.items.includes(productId)) {
        button.classList.add('active');
      } else {
        button.classList.remove('active');
      }
    });
  }

  // Pobierz listę ID produktów (przydatne na stronie wishlist)
  getProductIds() {
    return this.items;
  }
}

// Uruchomienie skryptu po załadowaniu DOM
document.addEventListener('DOMContentLoaded', () => {
  window.wishlist = new Wishlist(); // Udostępnij globalnie, aby mieć dostęp z konsoli
});

// Funkcja do renderowania produktów na stronie wishlist
function renderWishlistPage() {
  const container = document.getElementById('wishlist-container');
  const emptyMessage = document.getElementById('wishlist-empty');

  // Sprawdź, czy jesteśmy na stronie wishlist
  if (!container) return;

  container.innerHTML = ''; // Wyczyść kontener
  const wishlist = new Wishlist();
  const productIds = wishlist.getProductIds();

  if (productIds.length === 0) {
    emptyMessage.style.display = 'block';
    return;
  }

  emptyMessage.style.display = 'none';
  container.classList.add('loading'); // Dodaj klasę ładowania

  // Pobierz dane produktów z Shopify API
  fetch('/products.json')
    .then(response => response.json())
    .then(data => {
      // Filtruj produkty, aby znaleźć tylko te z wishlisty
      const wishlistProducts = data.products.filter(product =>
        productIds.includes(String(product.id)) // Upewnij się, że typy się zgadzają (string vs number)
      );

      // Dla każdego produktu stwórz kartę HTML
      wishlistProducts.forEach(product => {
        const productCard = createProductCard(product);
        container.appendChild(productCard);
      });
    })
    .catch(error => console.error('Error:', error))
    .finally(() => container.classList.remove('loading'));
}

// Pomocnicza funkcja tworząca HTML karty produktu
function createProductCard(product) {
  const card = document.createElement('div');
  card.className = 'grid__item'; // Dopasuj klasę do swojego gridu
  card.innerHTML = `
    <a href="${product.url}" class="product-card">
      <img src="${product.images[0]?.src || '//via.placeholder.com/300'}" alt="${product.title}" width="300">
      <h3>${product.title}</h3>
      <p>${product.price / 100} PLN</p>
    </a>
    <button class="wishlist-btn active" data-product-id="${product.id}">❤️</button>
  `;
  return card;
}

// Uruchom renderowanie strony wishlist po załadowaniu DOM
if (window.location.pathname === '/pages/wishlist') {
  document.addEventListener('DOMContentLoaded', renderWishlistPage);
}